// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import '@/assets/common/scss/index.scss'
import ElementUi from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import httpRequest from '@/utils/httpRequest'
import VueCookie from 'vue-cookie'
import Share from 'vue-social-share'
// import 'vue-social-share/dist/client.css'
import '../node_modules/social-share.js/dist/js/social-share.min.js'
import store from './store'
import './utils/dayjs'
// /* 获取museumCode */
import VuePhotoZoomPro from 'vue-photo-zoom-pro' // mjs 添加
// import { getFid } from '@/api/userservice/index'

// import vueSwiper from 'vue-awesome-swiper'
// import 'swiper/dist/css/swiper.css'
// Vue.use(vueSwiper)
Vue.use(Share)
Vue.use(ElementUi)
Vue.use(VueCookie)

Vue.prototype.$http = httpRequest
Vue.config.productionTip = false
/* 路由发生变化修改页面title */
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})
router.afterEach((to, from, next) => {
  window.scrollTo(0, 0)
})

Vue.use(VuePhotoZoomPro)
Vue.prototype.museumCode = 'cxggwhy'
// getFid({'domain': location.hostname}).then(res => {
//   if (res.data.rel) {
//     Vue.cookie.set('culturalCloud_fid', res.data.data.f)
//     Vue.cookie.set('museumCode', res.data.data.c)
//     Vue.prototype.museumCode = res.data.data.c
//     console.log(Vue.prototype.museumCode)
//   }
// })
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js